import React, { ReactElement, ReactNode } from 'react';
import cn from 'classnames';

type ActionButtonColor = 'primary' | 'secondary' | 'primary-white' | 'white';
type ActionButtonVariant = 'filled' | 'outlined';

type Props = {
    color ?: ActionButtonColor;
    variant ?: ActionButtonVariant;
    children : ReactNode;
    className ?: string;
    size ?: 'small' | 'medium' | 'large';
    [key : string] : any;
};

const ActionButton : React.FC<Props> = ({
    color = 'primary',
    variant = 'outlined',
    size = 'medium',
    children,
    className = '',
    ...props
}) : ReactElement => {
    const variantClasses = {
        filled: {
            'primary': 'bg-[#7041AC] text-white border-[#7041AC] hover:bg-transparent hover:text-[#7041AC]',
            'secondary': 'bg-[#14274D] text-white border-[#14274D] hover:bg-transparent hover:text-[#14274D]',
            'primary-white': 'bg-[#7041AC] text-white border-[#7041AC] hover:bg-transparent hover:border-white hover:text-white',
            'white': 'bg-white text-[#14274D] border-white hover:bg-transparent hover:border-[#14274D] hover:text-[#14274D]',
        },
        outlined: {
            'primary': 'text-[#7041AC] border-[#7041AC] hover:bg-[#7041AC] hover:text-white',
            'secondary': 'text-[#14274D] border-[#14274D] hover:bg-[#14274D] hover:text-white',
            'primary-white': 'text-white border-[#7041AC] hover:bg-[#7041AC] hover:border-white hover:text-white',
            'white': 'text-white border-white hover:bg-white hover:border-[#14274D] hover:text-[#14274D]',
        },
    };

    const sizeClasses = {
        small: 'px-5 py-3 text-md',
        medium: 'px-10 py-4 text-xl',
        large: 'px-16 py-6 text-2xl',
    };

    return (
        <button
            className={cn(
                'font-bold border-2 rounded-xl transition-all duration-300 cursor-pointer',
                sizeClasses[size],
                variantClasses[variant][color],
                className,
            )}
            {...props}
        >
            {children}
        </button>
    );
};

export default ActionButton;
